import Axios from 'axios';

const BASE_URL = 'https://api.obazrivko.com/api';

const axios = Axios.create({
  baseURL: BASE_URL
});

const setAuthHeader = (token) => {
  axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
}

const unsetAuthHeader = () => {
  delete axios.defaults.headers.common['authorization'];
}

let token = localStorage.getItem('token');
token && setAuthHeader(localStorage.getItem('token'));

export {
  axios as ApiBaseService,
  setAuthHeader,
  unsetAuthHeader
};
